import { Combo } from "./combo";
import { CouponModel } from "./coupon-model";
import { Detail } from "./detail";
import { MenuItem } from "./menu-item";
import { Order } from "./order";
import { Paycard } from "./paycard";

export class Orderpack 
{
    public PayCard: Paycard = new Paycard();
    public Order: Order = new Order();

    public Combos: Array<Combo> = new Array<Combo>();
    public MenuItems: Array<MenuItem> = new Array<MenuItem>();
    public Details: Array<Detail> = new Array<Detail>();
    public Coupon:CouponModel | undefined;
}
